export const KEY_ROTATION_REQUIRED = 1400087;
export const KEY_ALREADY_ROTATED = 1409004;
export const ENCRYPTION_KEY_URL_MISMATCH = 1400049;

// The default cluster when one is not provided (usually as 'US' from hydra)
export const DEFAULT_CLUSTER = 'urn:TEAM:us-east-2_a';
// The default service name for convo (currently identityLookup due to some weird CSB issue)
export const DEFAULT_CLUSTER_SERVICE = 'identityLookup';
